import { useDeviceType } from "@hooks/useDeviceType";
import { HeaderDesktop } from "./HeaderDesktop";
import { HeaderMobile } from "./HeaderMobile";

interface IParams {
    cartItemsNumber?: number;
    logoutCallback?(): void;
}

export const Header = ({ cartItemsNumber, logoutCallback }: IParams) => {
    const { isDesktop } = useDeviceType();

    if (isDesktop) {
        return <HeaderDesktop cartItemsNumber={cartItemsNumber} logoutCallback={logoutCallback} />;
    }

    return <HeaderMobile cartItemsNumber={cartItemsNumber} logoutCallback={logoutCallback} />;
};
